import Currency from "./Currency";
import Number from "./Number";
import Percent from "./Percent";
import Link from "./Link";
import Image from "./Image";

export const TableCell = { Currency, Number, Percent, Link, Image };

export default TableCell;
